import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) => ({
  
    root: {
    minWidth: 130,
    // maxWidth: 200,   
    height: 180,   
         
  },
  media: {
    height: 160,

  },  
  
  menuInfo: {
    fontFamily: 'Gilroy-ExtraBold, serif',
    color: '#000',
    fontSize: '1.5rem',
    display: "flex",
    justifyContent: "center",
    alignSelf: "center",
    marginTop: 25,
    [theme.breakpoints.down('sm')]: {
        display: "none",
    },
    [theme.breakpoints.down('xs')]: {
        display: "none",
    },
  },
  menus: {
    width: "90%",
    marginTop: 20,
    marginBottom: 80,
    marginLeft: 30,
    backgroundColor: "#FFFAF7",
    padding: 0,
    [theme.breakpoints.down('sm')]: {
      width: "100%",
      marginTop: 0,
      marginLeft: 0,
      padding: 0,
    },
    [theme.breakpoints.down('xs')]: {
      width: "100%",
      marginTop: 0,
      marginLeft: 0,
      padding: 0,
    },
    
  },
  list: {
    width: "17%",
    height: 240,
    marginLeft: "1.5%",
    marginRight: "1.5%",
    marginTop: 20,
    marginBottom: 50,
    padding: 0,
    [theme.breakpoints.down('sm')]: {
            width: "21%",
            height: 240,
            marginLeft: "2%",
            marginRight: "2%",
            marginTop: 20,
            marginBottom: 50,
            padding: 0,
    },
    [theme.breakpoints.down('xs')]: {
            width: "43%",
            height: 240,
            marginLeft: "3.5%",
            marginRight: "3.5%",
            marginTop: 10,
            marginBottom: 50,
            padding: 0,
    },
  },
  resInfo: {
    width: "100%",
    height: 40,
    color: "#ffffff",
    fontFamily: 'Gilroy-Light, serif',
    textTransform: 'capitalize',
    fontSize: '1rem',
    backgroundColor: '#e45826',
    fontWeight: 400,
    borderRadius: 0,
    marginTop: -237,
    '&:hover': {
      backgroundColor: '#e45826',
      boxShadow: 'none',
    },

    display:"flex",
    justifyContent:"center",
    alignContent: "center",
    alignItems:"center",
  },
  numberText: {
    height: 10,
    fontFamily: 'Gilroy-Light, serif',
    textTransform: 'capitalize',
    fontSize: '0.8rem',
    fontWeight: 400,
    color: '#000',
    marginTop: 4,
  },
    mainText: {
    fontFamily: 'Gilroy-ExtraBold, serif',
    color: '#fff',
    fontSize: '1.2rem',

  },
}))





